export default __webpack_public_path__ + "media/images/features/local_delivery/episode2/LP_01-0e4ab28dd12819d5b5484342da3f2823.jpg";